import { DateTimeUnit } from 'luxon';
import { isSameDateTimeUnit, parseAndFormatISO8601DateStr } from '../../../common/utilities/dateTimeUtils';

export const defaultReading = '--';
export const hourMinDateFormat = 'h:mm a';
export const hourlyForecastScrollableViewId = 'hourly-forecast-scrollable-view-id';
export const largeHourlyForecastViewId = 'large-hourly-forecast-view-id';
export const hourlyForecastCardsListId = 'hourly-forecast-cards-list-id';
export const hourlyForecastCardBaseId = 'hourly-forecast-card-base-id-';
export const dailyForecastScrollableViewId = 'large-daily-forecast-page-view-id';
export type ChartMatchType = 'HourCard' | 'AdPlacement' | 'SolarPlacement';

export const daysOfTheWeek = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
];

export const isAdBreak = (hourlyForecastCardIndex: number, isMobile: boolean): boolean => {

    const mod = hourlyForecastCardIndex % 12;
    
    if (mod - 3 === 0 && !isMobile
        || mod - 9 === 0 && isMobile) {
        return true;
    }

    return false;
};

export const datesAreSameDay = (currDate: string, nextDate: string, dateTimeUnit?: DateTimeUnit): boolean => {
    if (currDate && nextDate) {
        const result = isSameDateTimeUnit(currDate, nextDate, dateTimeUnit);
        return result;
    }
    return false;
};

export const formatTemperatureReadings = (value: string | number): string => {
    const formatted = parseFloat(value as string);
    return Math.abs(formatted) >= 0 ? `${formatted}°` : defaultReading;
};

export const formatDateStr = (rawDateStr: string, dateFormat: string): string | undefined => {
    if (rawDateStr && dateFormat) {
        const formattedDateStr = parseAndFormatISO8601DateStr(rawDateStr, dateFormat);
        if (formattedDateStr) {
            return formattedDateStr;
        }
        return defaultReading;
    }
    return defaultReading;
};

export const forecastViewScrollHandler = (element: HTMLElement, duration = 500, scrollTo: number = 170 * 6): void => {
    const start = element.scrollLeft;
    const change = scrollTo - start;
    let currentTime = 0;
    const increment = 20;

    function animateScroll() {
        currentTime += increment;

        const easeInOutVal = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollLeft = easeInOutVal;

        if (currentTime < duration && window) {
            window?.requestAnimFrame(animateScroll); // using extension util from app.extensions to support different browser versions of requestAnimationFrame.
        } 
    }
    
    if (element) {
        animateScroll();
    }
};

export const forecastHourSlug = (date: string): string | undefined => {
    if (date && typeof date === 'string') {
        const result = parseAndFormatISO8601DateStr(date, 'yyyyMMddHH', true);
        return result;
    }
    return;
};